import React, { Component } from "react";
import HistoricPayrollForm from "../HistoricPayrollForm/HistoricPayrollForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimePage
Description : Componente que contienen el formulario de la pantalla Overtime
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente OvertimeForm
================================================================================ */
class HistoricPayrollPage extends Component{
    render(){
        return(
            <div>                    
                <HistoricPayrollForm/>
            </div>
        )   
    }
}

export default HistoricPayrollPage;